import {FieldCheckbox} from "@magoosh/lib/field_checkbox/template";

export default FieldCheckbox;
